import {
  AssetInstance, AssetCustomField, Template, TemplateField,
} from '../../constants/Types';

// eslint-disable-next-line import/prefer-default-export
export const loadCustomFields = (
  template: Template,
  asset: AssetInstance,
  includeGeo: boolean = false,
) => [
  ...template?.customfields
    ?.sort((a: TemplateField, b: TemplateField) => a.Name.toLowerCase()
      .localeCompare(b.Name.toLowerCase()))
    ?.map((field: TemplateField) => {
      const value: string = asset?.customFields
        ?.filter((customField: AssetCustomField) => customField.name === field.Name)[0]?.value ?? '';
      return { format: field.Format, name: field.Name, value };
    }) ?? [],
  ...(includeGeo ? asset.customFields?.filter((field: AssetCustomField) => ['geox', 'geoy']
    .includes(field.name.trim().toLowerCase())) ?? [] : []),
].map((field: AssetCustomField) => ({ ...field, value: field.value?.toString() }));
